import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { RolePermissionsService } from '../../services/role-permissions/role-permissions.service';


export class ExceptRolesDirective {

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
              private roleService: RolePermissionsService) {
  }

   set exceptRoles(roles: string[]) {
    this.roleService.exceptRoles(roles).then((isAccepted) => {
      if (isAccepted) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[exceptRoles]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
{type: ViewContainerRef, },
{type: RolePermissionsService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'exceptRoles': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
